module.exports = __webpack_public_path__ + "static/media/pmrAudio.1b25ab3c.m4a";